import axios from 'axios';
import { Cookies } from 'react-cookie';
import { refreshToken } from 'store/slice/SliceAuth'; // refreshToken 액션 임포트
import { BASE_URL } from 'store/baseConfig';
import { store } from 'index';


const axiosInstance = axios.create({
    baseURL: BASE_URL, // 기본 URL 설정
    withCredentials: true,
});

let isRefreshing = false;
let refreshSubscribers = [];

function onRrefreshed(token) {
    refreshSubscribers.map((callback) => callback(token));
}

function addRefreshSubscriber(callback) {
    refreshSubscribers.push(callback);
}

// 요청 인터셉터
axiosInstance.interceptors.request.use(
    (config) => {
        const cookies = new Cookies();
        const csrfToken = cookies.get('csrftoken');
        if (csrfToken) {
            config.headers['X-CSRFToken'] = csrfToken; // CSRF 토큰 추가
        }

        // loginUserInfo 읽어서 Authorization 헤더에 추가
        const state = store.getState();
        const { loginUserInfo } = state.auth;
        if (loginUserInfo && loginUserInfo.access) {
            config.headers['Authorization'] = `Bearer ${loginUserInfo.access}`; // access 토큰 추가
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error instanceof Error ? error : new Error(error.message || '요청 처리 중 오류가 발생했습니다.'));
    }
);

// 응답 인터셉터
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        try{
            const test = error.response.status
        } catch (statusError) {
            return Promise.reject(new Error(error.message || '네트워크 오류가 발생했습니다.'));
        }
        
        // blob 응답 타입인 경우 특별 처리
        if (originalRequest.responseType === 'blob' && error.response) {
            // blob 응답에서 에러가 발생한 경우, JSON 에러 메시지를 확인
            try {
                if (error.response.data instanceof Blob) {
                    const text = await error.response.data.text();
                    const errorData = JSON.parse(text);
                    if (errorData.error || errorData.message) {
                        const blobError = new Error(errorData.message || errorData.error || '다운로드 중 오류가 발생했습니다.');
                        blobError.response = { ...error.response, data: errorData };
                        return Promise.reject(blobError);
                    }
                }
            } catch (parseError) {
                // JSON 파싱 실패 시 원래 에러 반환
                console.warn('Blob 에러 응답 파싱 실패:', parseError);
            }
        }
        
        // 401 에러 처리
        if (error.response.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return new Promise((resolve) => {
                    addRefreshSubscriber((token) => {
                        originalRequest.headers['Authorization'] = `Bearer ${token}`;
                        resolve(axiosInstance(originalRequest));
                    });
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            const state = store.getState();
            const { loginUserInfo } = state.auth;

            try {
                const newTokens = await store.dispatch(refreshToken()).unwrap();
                isRefreshing = false;
                onRrefreshed(newTokens.access);
                refreshSubscribers = [];

                originalRequest.headers['Authorization'] = `Bearer ${newTokens.access}`;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                isRefreshing = false;
                refreshSubscribers = [];
                
                return Promise.reject(refreshError instanceof Error ? refreshError : new Error(refreshError.message || '토큰 갱신 중 오류가 발생했습니다.'));
            }
        }

        return Promise.reject(error instanceof Error ? error : new Error(error.message || '응답 처리 중 오류가 발생했습니다.'));
    }
);

export default axiosInstance;
